






































import { BookCommentComponents } from '../../comment/components'
import { bookGoodsModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'
import { navigateTo } from '@/router'

export default defineClassComponent(
  {
    components: BookCommentComponents,
  },
  () =>
    class {
      bookGoodsModel = bookGoodsModelProvider.inject()

      handleMoreClick = () => {
        navigateTo('BookCommentIndex', {
          goodsId: this.bookGoodsModel.value.goodsId,
        })
      }
    },
)
